import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { LOCALE_DEFS, toLocale } from "@prostocheck/i18n";

/**
 * Keeps `<html lang>` and the tab title in step with the chosen language.
 * index.html ships the Ukrainian defaults so the page is never unlabelled
 * before React mounts.
 */
export const useDocumentLanguage = (): void => {
  const { t, i18n } = useTranslation();
  const { lang } = LOCALE_DEFS[toLocale(i18n.resolvedLanguage)];
  const title = t("documentTitle");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = title;
  }, [lang, title]);
};
